import { useMemo } from "react";
import AddressAutocomplete from "./AddressAutocomplete";
import AutocompleteInput from "./AutocompleteInput";
import HistoryInput from "./HistoryInput";

const splitCivico = (s) => {
  const m = String(s || "").trim().match(/^(.*?)[,\s]+(\d+[A-Za-z]?(?:\/\w+)?)$/);
  return m ? { via: m[1], civico: m[2] } : { via: String(s || "").trim(), civico: "" };
};

// Valori già inseriti nelle compagnie, raggruppati per campo (per i suggerimenti predittivi).
export const useCompPool = (rows) => useMemo(() => {
  const out = {};
  (rows || []).forEach((r) => Object.entries(r || {}).forEach(([k, v]) => { if (typeof v === "string" && v.trim()) (out[k] = out[k] || []).push(v.trim()); }));
  return out;
}, [rows]);

// Campo predittivo della scheda compagnia: indirizzo/comune compilano Provincia e CAP; gli altri suggeriscono valori esistenti.
export default function CompagniaSmartField({ fkey, form, setForm, pool, testId, className = "" }) {
  const set = (patch) => setForm((f) => ({ ...f, ...patch }));
  const cls = `h-9 w-full px-3 rounded-md bg-slate-900/60 border border-slate-700 text-sm text-slate-100 ${className}`;
  if (fkey === "indirizzo") {
    return (
      <div className="mt-1.5">
        <AddressAutocomplete value={form.indirizzo || ""} onChange={(v) => set({ indirizzo: v })} city={form.comune} prov={form.provincia} testId={testId} inputClassName={cls}
          onPick={(p) => { const s = splitCivico(p.indirizzo); set({ indirizzo: s.via, ...(s.civico ? { numero_civico: s.civico } : {}), comune: p.comune || form.comune || "", provincia: (p.provincia || form.provincia || "").toUpperCase(), cap: p.cap || form.cap || "" }); }} />
      </div>
    );
  }
  if (fkey === "comune") {
    return (
      <div className="mt-1.5">
        <AutocompleteInput source="comuni" value={form.comune || ""} onChange={(v) => set({ comune: v })} testId={testId} placeholder="Inizia a digitare il comune…"
          className="bg-slate-900/60 border-slate-700" onSelectItem={(it) => set({ comune: it.nome, provincia: it.provincia || "", cap: it.cap || form.cap || "" })} />
      </div>
    );
  }
  if (fkey === "provincia" || fkey === "cap") {
    return (
      <input value={form[fkey] || ""} onChange={(e) => set({ [fkey]: fkey === "provincia" ? e.target.value.toUpperCase() : e.target.value })} data-testid={testId}
        placeholder="—" title="Si compila dal Comune o dall'Indirizzo" className={`mt-1.5 font-mono ${fkey === "provincia" ? "uppercase" : ""} ${cls}`} />
    );
  }
  return <HistoryInput value={form[fkey]} onChange={(v) => set({ [fkey]: v })} options={pool[fkey] || []} testId={testId} className={className} />;
}
